export default __webpack_public_path__ + "static/media/Mark-2-HUD-Altimeter.6ca90fbf.jpg";